"use client";
import { getLocalStorage, setLocalStorage } from "@/lib/storage-helper";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Button } from "./ui/button";

export default function CookieBanner() {
  const [cookieConsent, setCookieConsent] = useState<boolean | null>(null);
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    const storedCookieConsent = getLocalStorage("cookie_consent", null);

    if (storedCookieConsent !== null) setCookieConsent(storedCookieConsent);
  }, [setCookieConsent]);

  useEffect(() => {
    const newValue = cookieConsent ? "granted" : "denied";

    window.gtag("consent", "update", {
      analytics_storage: newValue,
    });

    setLocalStorage("cookie_consent", cookieConsent);
  }, [cookieConsent]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 3000);

    return () => clearTimeout(timer); // Cleanup the timeout on unmount
  }, []);
  if (show)
    return (
      <div
        className={`mb-2 mx-auto max-w-max sm:max-w-sm
          lg:max-w-lg
                          fixed bottom-0 left-2 right-2 sm:right-auto
                          ${cookieConsent != null ? "hidden" : "flex"} 
                           px-3 md:px-4 py-3 lg:py-4 justify-between items-center flex-col sm:flex-row gap-4  
                           bg-background rounded-xl border-neutral-700 border shadow`}
      >
        <div className="flex flex-col items-center gap-2 lg:flex-row lg:gap-5">
          <div className="text-center  text-black text-sm lg:text-left w-fit">
            <p>
              Utilizamos cookies propias y de terceros para obtener datos
              estadísticos de la navegación de nuestros usuarios y mejorar
              nuestros servicios.
              <Link href="/politica-de-cookies">
                <span className="inline-block text-primary underline">
                  Más información
                </span>
              </Link>
            </p>
          </div>

          <div className="flex gap-2 mt-3 lg:text-sm lg:flex-1 lg:mt-0">
            <Button variant="outline" onClick={() => setCookieConsent(false)}>
              Rechazar
            </Button>
            <Button onClick={() => setCookieConsent(true)}>Aceptar</Button>
          </div>
        </div>
      </div>
    );

  return;
}
